import {
  ReferralSearchPayload,
  ReferralDetailsPayload,
  NtuPatientPayload,
  AuthorizationPayload,
  ReAuthRequestPayload,
  SlotsPayload,
  DocumentReviewPayload,
  UpdateStartOfCareDatePayload,
  ViewedNotificationDetails,
  MaxAllowedSocDatePayload,
} from "../models/Referral";
import API from "./api";
import { getAuthType } from "../utils";
import { UploadNoMNCDocumentDetails } from "../routes/HomeScreen/components/NoMncModal";

export const GetReferralListByProviderId = (
  baseUrl: string,
  payload: ReferralDetailsPayload
) =>
  API.get(
    `${baseUrl}api/ReferralService/referrals/${payload.providerId}/${payload.pageNo}/${payload.pageSize}`
  );

export const GetReferralListBySearchTerm = (
  baseUrl: string,
  payload: ReferralSearchPayload
) =>
  API.get(
    `${baseUrl}api/ReferralService/Portal/${payload.providerId}/${payload.searchTerm}?page=${payload.pageNo}&pageSize=${payload.pageSize}`
  );

export const GetReferralAuthHistory = (baseUrl: string, referralId: number) =>
  API.get(`${baseUrl}api/ReferralService/Portal/${referralId}`);

export const PostNtuPatient = (baseUrl: string, payload: NtuPatientPayload) =>
  API.postApi(`${baseUrl}api/admin/sendNtuEmail`, payload);

export const GetMasterNtuReason = (baseUrl: string, typeId: boolean) =>
  API.get(`${baseUrl}api/Patients/NTUReason/${typeId}`);

export const PostPriorAuthSubmit = (
  baseUrl: string,
  payload: AuthorizationPayload
) =>
  API.postApi(
    `${baseUrl}api/ReferralService/CreatePriorAuthorization`,
    payload
  );

export const UploadDocumentsFile = (configUrl: string, payload: any) =>
  API.postApi(
    `${configUrl}api/ReferralService/AddPriorAuthorizationDocument`,
    payload
  );

export const GetSlots = (baseUrl: string, payload: SlotsPayload) =>
  API.get(`${baseUrl}api/ReferralService/GetAuthPeriodDates?patientEligibilityId=${payload.patientEligibilityId}&type=${payload.type}&startOfCareDate=${payload.startOfCareDate}${getAuthType(payload)}`);

export const GetReAuthReferralData = (baseUrl: string, referralId: number) =>
  API.get(`${baseUrl}api/ReferralService/Portal/ReAuth/${referralId}`);

export const GetReAuthDefaultServiceProvider = (
  baseUrl: string,
  providerId: number
) => API.get(`${baseUrl}api/Operator/GetProvider/${providerId}`);

export const PostReAuthAuthSubmit = (
  baseUrl: string,
  payload: ReAuthRequestPayload
) =>
  API.postApi(
    `${baseUrl}api/ReferralService/CreateReAuthorization`,
    payload
  );

  export const PostIngestProcessSubmit = (
    baseUrl: string,
    payload: any
  ) => API.postApi(`${baseUrl}api/Ingest/ProcessPayload`, payload);

  export const GetDinaLaunchUrl = (baseUrl: string, email: string) =>
    API.get(`${baseUrl}api/Dina/launch?emailaddress=${email}&isEmbedded=true`);

  export const PostDocumentReview = (baseUrl: string, payload: DocumentReviewPayload) =>
  API.postApi(`${baseUrl}api/Portal/searchDocument`, payload);
  
  export const GetDocumentDownload = (
    configUrl: string,
    blobId: number,
    type?: string
) => API.get(`${configUrl}api/Blob/GetPortalBlobById/${blobId}`, type);

export const GetPhysicianDetails = (baseUrl: string, referralId: number) =>
  API.get(`${baseUrl}api/ReferralService/physician/${referralId}`);

export const GetDisciplineStatusList = (baseUrl: string, referralId: number) =>
  API.get(`${baseUrl}api/ReferralService/disciplines/${referralId}?pageNo=0&pageSize=0&userId=0&skipPagination=true`);

export const GetIsRetroDetails = (baseUrl: string, startOfCareDate: string, userSpecificReceivedDateTime: string) =>
  API.get(`${baseUrl}api/ReferralService/IsRetro/${startOfCareDate}?userSpecificReceivedDateTime=${userSpecificReceivedDateTime}`);

export const PutUploadNoMNCDocumentDetails = (baseUrl: string, payload: UploadNoMNCDocumentDetails) =>
  API.putApi(`${baseUrl}api/ReferralService/UploadNoMNCDocumentDetails`, payload);

export const GetNotificationsList = (baseUrl: string, userId: string) =>
  API.get(`${baseUrl}api/Notifications/showNotifications?userId=${userId}`);

export const PostViewedNotificationDetails = (baseUrl: string, payload: ViewedNotificationDetails) =>
  API.postApi(`${baseUrl}api/Notifications/markAsRead`, payload);

export const GetDownloadDocumentOfNotification = (
    configUrl: string,
    blobId: number,
    type?: string,
    onDownloadProgress?: (percent: number) => void
) => API.get(`${configUrl}api/Blob/GetDocumentBlobById/${blobId}`, type, onDownloadProgress);

export const PostReferralDocumentReview = (
  baseUrl: string,
  payload: DocumentReviewPayload,
) => API.postApi(`${baseUrl}api/ReferralService/searchDocument`, payload);

export const GetBlobByIdDownload = (
  configUrl: string,
  blobId: number,
  type?: string,
) => API.get(`${configUrl}api/Blob/GetNonEditableDocumentById/${blobId}`, type);

export const PostUpdateStartOfCareDate = (
  baseUrl: string,
  payload: UpdateStartOfCareDatePayload,
) => API.postApi(`${baseUrl}api/ReferralService/UpdateStartOfCareDate`, payload);

export const PostAuthNotifications = (
  baseUrl: string,
  referralId: number
) =>
  API.postApi(`${baseUrl}api/AuthNotifications`, { referralId });

export const GetAuthNotificationsDownload = (baseUrl: string, blobId: number) =>
  API.get(`${baseUrl}api/Blob/GetBlobById/${blobId}`);

export const GetMaxAllowedSocDate = (baseUrl: string, payload: MaxAllowedSocDatePayload) => {
  const query = payload.patientEligibilityId
    ? `patientEligibilityId=${payload.patientEligibilityId}`
    : `referralId=${payload.referralId}`;
  return API.get(`${baseUrl}api/ReferralService/MaxAllowedSocDate?${query}`);
};